(function($) {

    // Vars

    var isIE = document.body.style.msTouchAction !== undefined;
    var viewportHeight = $(window).height();


    $(document).ready(function() {
        objectFitImages();
        lazyImages();
    });

    $(window).on('resize', function() {
        viewportHeight = $(window).height();
    });

    //
    // Polyfill for object.assign, needed for lozad plugin to work on IE11
    //
    window.ObjectAssign.polyfill();

    //
    // Lazy loading on scroll
    //,
    function lazyImages() {
        var observer = lozad('.lozad', {
            rootMargin: viewportHeight/4+'px 0px '+viewportHeight/4+'px 0px',
            threshold: 0.05,
            loaded: function(element) {
                if (!isIE) {
                    element.onload = function () {
                        if ($(element).parent().hasClass('image-reveal-wrap')) {
                            element.classList.add('lazy-loaded');
                            $(element).parent().addClass('reveal');
                        } else {
                            element.classList.add('lazy-loaded');
                        }
                    }
                } else {
                    if ($(element).parent().hasClass('image-reveal-wrap')) {
                        element.classList.add('lazy-loaded');
                        $(element).parent().addClass('reveal');
                    } else {
                        element.classList.add('lazy-loaded');
                    }
                }

                if ($(element).hasClass('video')) {
                    $(element).one('canplay', function() {
                        element.classList.add('lazy-loaded');
                        $(element).parent().addClass('reveal');
                    });
                }
            }
        });
        observer.observe();
    }

})( jQuery );